import React,{useEffect, useContext} from 'react';
import LeftSitebarMenu from '../../components/leftSitebarMenu/LeftSitebarMenu';
import MainMenu from '../../components/mainMenu/MainMenu';
import RightSitebarMenu from '../../components/rightSitebarMenu/RightSitebarMenu';
import FilterAndShort from './../../components/filterAndShort/FilterAndShort';
import live from '../../assets/img/chatroom-imgs/golive.svg';
import { ShowHideSitebar } from './../../App';
import closerIcon from '../../assets/img/feed-imgs/navbar/closeicon.svg';

const ChatRoom = () => {
    const [showHideSidebar, setShowHideSidebar] = useContext(ShowHideSitebar)
    useEffect(()=>{ /** setting the page name for the sidebars of this page to work */
        const setPageName = {...showHideSidebar}
        setPageName.pageName = 'chatRoom';
        setPageName.chatRoom.left = false;
        setPageName.chatRoom.right = false;
        setShowHideSidebar(setPageName)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const closeSidebar =(whichSidebar, status)=>{
        const newStatus = {...showHideSidebar}
        if(whichSidebar === 'left'){
            newStatus.chatRoom.left = status /** changing the page name for left sidebar to toggle */
            setShowHideSidebar(newStatus) /** changing the page name for right sidebar to toggle */
        }
        if(whichSidebar === 'right'){
            newStatus.chatRoom.right = status
            setShowHideSidebar(newStatus)
        }
    }
    return (
        <>
            {/* Main Menu bar here */}
            <MainMenu></MainMenu>
            {/* Menu bar start here */}
            <div className="container-fluid container-lg">
                <div className="row gap-5 gap-lg-0">
                    {/* Left Site Bar Start here */}
                    <div className={`col-12 col-lg-2  d-lg-block ${showHideSidebar?.chatRoom?.left ? 'd-block right-sitebarmenu' : 'd-none'}`}>
                         <div className="d-flex d-lg-none justify-content-end mb-3">
                            <div onClick={()=>closeSidebar("left", false)} className="d-flex justify-content-center align-items-center action-button rounded-circle shadow-sm p-2 m-3" style={{ height: "32px", width: "32px"}}>
                                <img src={closerIcon} alt="" className='close-menu-button' />
                            </div>
                        </div>
                        <LeftSitebarMenu></LeftSitebarMenu>
                    </div>    
                    <div className="col-lg-6">
                        {/* Add A Clip and Filte section here */}
                        <div className="row my-2">
                            {/* Filter and Short Seciton Component */}
                                <div className="row mb-2 gap-2 gap-lg-0">
                                    <div className="col-12 col-lg-8 col-md-6">
                                        <button className="custm-pill-button-small rounded-pill px-3 py-2 post_btn d-flex align-items-center" type="button"> <img src="" alt="" /><img src={live} alt="" className='me-3' /> ChatRoom</button>
                                    </div>
                                    <div className="col-12 col-lg-4 d-flex justify-content-start justify-content-lg-end align-items-start gap-4">
                                        <FilterAndShort></FilterAndShort>
                                    </div>
                                </div>
                        </div>
                    </div>
                    {/* Right Site Menu Bar  */}
                    <div className={`col-12 col-lg-4  d-lg-block ${showHideSidebar?.chatRoom?.right ? 'd-block right-sitebarmenu' : 'd-none'}`}>
                    <div className="d-flex d-lg-none justify-content-end mb-3">
                            <div onClick={()=>closeSidebar("right", false)} className="d-flex justify-content-center align-items-center action-button rounded-circle shadow-sm p-2 m-3" style={{ height: "32px", width: "32px"}}>
                                <img src={closerIcon} alt="" className='close-menu-button' />
                            </div>
                        </div>
                        <RightSitebarMenu />
                    </div>    
                </div>
            </div>
            
        </>
    );
};

export default ChatRoom;